import fetch from 'utils/fetch'
export function getProjectListAudit () {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/project/getProjectListAudit`,
    method: 'post'
  })
}
// audit
export function getLabListAudit (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabListAudit`,
    method: 'post',
    data
  })
}
export function getLabListAuditCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabListAuditCount`,
    method: 'post',
    data
  })
}
export function modifyLabAuditStatus (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/modifyLabAuditStatus`,
    method: 'post',
    data
  })
}
// 申请进入实验室
export function applyForLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/applyForLab`,
    method: 'post',
    data
  })
}
export function getLabApply (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabApply`,
    method: 'post',
    data
  })
}
export function getLabApplyCount (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/getLabApplyCount`,
    method: 'post',
    data
  })
}
export function updateApplyForLab (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/log/updateApplyForLab`,
    method: 'post',
    data
  })
}
// 审核lab
export function updateLabAudit (data) {
  return fetch({
    url: `${process.env.PERMISSION_API}/backend/lab/updateLabAudit`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/audit.js